import { render, staticRenderFns } from "./OrderedMaterials.vue?vue&type=template&id=5a576209"
import script from "./OrderedMaterials.vue?vue&type=script&lang=ts"
export * from "./OrderedMaterials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports